import type { ReactNode } from 'react'

import { Chip, type TChipProps } from '@/src/elements/chip'
import type { TChipVariantProps } from '@/src/elements/chip/chip-variants'

import { useCommunityFrequencyText, type TCommunityFrequencyProps } from '../../hooks/useCommunityFrequencyText'

export const CommunityFrequencyChip = ({
  fontWeight,
  colors = 'primary',
  ...props
}: TCommunityFrequencyProps & {
  colors?: TChipVariantProps['colors']
  fontWeight?: TChipProps['fontWeight']
}): ReactNode => (
  <Chip
    text={useCommunityFrequencyText(props)}
    colors={colors}
    variant="flat"
    style={{ maxWidth: 'auto' }}
    fontWeight={fontWeight}
  />
)
